import React from "react";
import { v4 as uuidv4 } from "uuid";
import UniversalDatasetTableRow from "./UniversalDatasetTableRow";
import UniversalDatasetTableHeaderRow from "./UniversalDatasetTableHeaderRow";
import { IUniversalDatasetTableConfig } from "./universal-dataset-table-editor/CellValuesEditor";
import "./UniversalDatasetTable.scss";

const UniversalDatasetTable = (props: IUniversalDatasetTableConfig) => {
  return (
    <div className="main-main-window">
      {props && props.rows.length > 0 && (
        <table className="main-window">
          <thead>
            {props.showColumnHeaders && !props.hideHeader && (
              <UniversalDatasetTableHeaderRow columnsOptions={props.columnsOptions} />
            )}
          </thead>
          <tbody className="universal-table-body">
            {props.rows.map(row => (
              <UniversalDatasetTableRow
                key={uuidv4()}
                rowData={row}
                updateFrequency={props.updateFrequency ?? 0}
                columnsOptions={props.columnsOptions}
                compactMode={props.compactMode}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UniversalDatasetTable;
